import React from "react";
import img from "../blog/assets/unsplash_L1y9f5O8wiA.svg";
import Emailsub from "../blog/Emailsub";

const Dummyblog = () => {
  return (
    <>
      <div className="w-full h-[3226px] relative bg-white">
        <div className="w-[771.24px] h-[138.09px] left-[53.76px] top-[205.80px] absolute text-neutral-800 text-[46px] font-semibold font-['Poppins'] leading-[69px]">
          Lorem ipsum dolor sit amet consectetur. Id tortor posuere.
        </div>
        <img
          className="w-full h-[490.08px] left-[-20.62px] top-[456.12px] absolute rounded-[21.75px]"
          src={img}
          alt=""
        />
        <div className="left-[54px] top-[350.77px] absolute text-gray-800 text-base font-normal font-['Poppins']">
          12/12/2012
        </div>
        <div className="h-[2158px] left-[54px] top-[1033.50px] absolute flex-col justify-start items-start gap-[35px] inline-flex">
          <div className="w-[744px] text-neutral-900 text-base font-normal font-['Poppins'] leading-normal">
            Lorem ipsum dolor sit amet consectetur. Quis urna neque quis
            pellentesque risus nisl diam natoque. Facilisis lacus nibh nibh
            lectus venenatis. Amet nibh elementum duis euismod id fringilla sed
            tincidunt at. Ultrices felis suspendisse amet tellus ac sed lorem.
            Sagittis eget lobortis iaculis sodales. Fames molestie varius eget
            convallis risus varius. Quis nec tortor ut proin arcu vel.
            Scelerisque blandit aliquet bibendum ipsum feugiat integer
            scelerisque in donec. Dignissim amet lectus amet luctus. Ultricies
            vel urna faucibus dolor aenean nunc. Molestie cras vitae sit
            eleifend eget ut netus gravida. Eget eros morbi urna nisl vel in
            aenean. Est nunc nunc quis ultricies consectetur lorem faucibus.
            <br />
            Nunc posuere tellus elementum aliquam. Commodo orci mattis dignissim
            congue pellentesque sit varius orci pulvinar. Pellentesque vitae
            fermentum a auctor sit eget. Orci ipsum blandit auctor non vitae et
            auctor congue. In tristique nulla id tristique turpis pharetra purus
            dictum. Nibh tincidunt fringilla nisl tellus nec in adipiscing.
            Auctor non sem in cras et sagittis ullamcorper ut ac. Natoque
            maecenas praesent faucibus vel in enim. Quis commodo pulvinar sed
            amet cras eget pellentesque dui. Lectus egestas purus ut cras mauris
            sed vel.
            <br />
            Justo ultricies morbi nibh eget odio vitae turpis. Aliquam vel
            tincidunt lectus lectus natoque morbi commodo fringilla. Maecenas
            malesuada feugiat imperdiet tincidunt varius. Vehicula tristique mi
            nulla nunc tortor aliquet nunc velit at. Ipsum pellentesque aliquam
            iaculis scelerisque eu convallis congue. Enim nibh id congue ipsum
            dictum parturient ut. Egestas at suspendisse volutpat accumsan
            venenatis in tempor.
            <br />A libero ut integer egestas neque et rhoncus. Est nibh viverra
            faucibus mi. Est sit ipsum vitae justo semper volutpat sit sit
            justo. Sed dolor nulla tellus consequat vivamus et tempor sagittis
            bibendum. Massa nisl vivamus urna dolor praesent commodo. Justo
            fermentum aenean hendrerit mi. Ultrices massa et auctor arcu.
            Vulputate facilisis sagittis sit integer. Commodo eros ultrices enim
            velit. At id vitae mauris pellentesque. Egestas cras sed elit eu a
            amet mauris dui. Aliquam facilisis tempor orci elementum donec
            sagittis donec pretium ultrices. Cursus ipsum sollicitudin quis non
            viverra sapien. Vulputate dictum nec lorem viverra elit dignissim
            tempus venenatis sit.
            <br />
            Hendrerit non posuere sagittis sem. Lacinia justo nibh sit iaculis
            in orci fringilla nec. Nisi porta tincidunt aliquet curabitur
            pulvinar eros metus. Suspendisse orci urna.
          </div>
          <div className="w-[744px] text-neutral-900 text-base font-normal font-['Poppins'] leading-normal">
            Lorem ipsum dolor sit amet consectetur. Quis urna neque quis
            pellentesque risus nisl diam natoque. Facilisis lacus nibh nibh
            lectus venenatis. Amet nibh elementum duis euismod id fringilla sed
            tincidunt at. Ultrices felis suspendisse amet tellus ac sed lorem.
            Sagittis eget lobortis iaculis sodales. Fames molestie varius eget
            convallis risus varius. Quis nec tortor ut proin arcu vel.
            Scelerisque blandit aliquet bibendum ipsum feugiat integer
            scelerisque in donec. Dignissim amet lectus amet luctus. Ultricies
            vel urna faucibus dolor aenean nunc. Molestie cras vitae sit
            eleifend eget ut netus gravida. Eget eros morbi urna nisl vel in
            aenean. Est nunc nunc quis ultricies consectetur lorem faucibus.
            <br />
            Nunc posuere tellus elementum aliquam. Commodo orci mattis dignissim
            congue pellentesque sit varius orci pulvinar. Pellentesque vitae
            fermentum a auctor sit eget. Orci ipsum blandit auctor non vitae et
            auctor congue. In tristique nulla id tristique turpis pharetra purus
            dictum. Nibh tincidunt fringilla nisl tellus nec in adipiscing.
            Auctor non sem in cras et sagittis ullamcorper ut ac. Natoque
            maecenas praesent faucibus vel in enim. Quis commodo pulvinar sed
            amet cras eget pellentesque dui. Lectus egestas purus ut cras mauris
            sed vel.
            <br />
            Justo ultricies morbi nibh eget odio vitae turpis. Aliquam vel
            tincidunt lectus lectus natoque morbi commodo fringilla. Maecenas
            malesuada feugiat imperdiet tincidunt varius. Vehicula tristique mi
            nulla nunc tortor aliquet nunc velit at. Ipsum pellentesque aliquam
            iaculis scelerisque eu convallis congue. Enim nibh id congue ipsum
            dictum parturient ut. Egestas at suspendisse volutpat accumsan
            venenatis in tempor.
            <br />A libero ut integer egestas neque et rhoncus. Est nibh viverra
            faucibus mi. Est sit ipsum vitae justo semper volutpat sit sit
            justo. Sed dolor nulla tellus consequat vivamus et tempor sagittis
            bibendum. Massa nisl vivamus urna dolor praesent commodo. Justo
            fermentum aenean hendrerit mi. Ultrices massa et auctor arcu.
            Vulputate facilisis sagittis sit integer. Commodo eros ultrices enim
            velit. At id vitae mauris pellentesque. Egestas cras sed elit eu a
            amet mauris dui. Aliquam facilisis tempor orci elementum donec
            sagittis donec pretium ultrices. Cursus ipsum sollicitudin quis non
            viverra sapien. Vulputate dictum nec lorem viverra elit dignissim
            tempus venenatis sit.
            <br />
            Hendrerit non posuere sagittis sem. Lacinia justo nibh sit iaculis
            in orci fringilla nec. Nisi porta tincidunt aliquet curabitur
            pulvinar eros metus. Suspendisse orci urna.
          </div>
          <div className="w-[744px] text-neutral-900 text-base font-normal font-['Poppins'] leading-normal">
            Lorem ipsum dolor sit amet consectetur. Quis urna neque quis
            pellentesque risus nisl diam natoque. Facilisis lacus nibh nibh
            lectus venenatis. Amet nibh elementum duis euismod id fringilla sed
            tincidunt at. Ultrices felis suspendisse amet tellus ac sed lorem.
            Sagittis eget lobortis iaculis sodales. Fames molestie varius eget
            convallis risus varius. Quis nec tortor ut proin arcu vel.
            Scelerisque blandit aliquet bibendum ipsum feugiat integer
            scelerisque in donec. Dignissim amet lectus amet luctus. Ultricies
            vel urna faucibus dolor aenean nunc. Molestie cras vitae sit
            eleifend eget ut netus gravida. Eget eros morbi urna nisl vel in
            aenean. Est nunc nunc quis ultricies consectetur lorem faucibus.
            <br />
            Nunc posuere tellus elementum aliquam. Commodo orci mattis dignissim
            congue pellentesque sit varius orci pulvinar. Pellentesque vitae
            fermentum a auctor sit eget. Orci ipsum blandit auctor non vitae et
            auctor congue. In tristique nulla id tristique turpis pharetra purus
            dictum. Nibh tincidunt fringilla nisl tellus nec in adipiscing.
            Auctor non sem in cras et sagittis ullamcorper ut ac. Natoque
            maecenas praesent faucibus vel in enim. Quis commodo pulvinar sed
            amet cras eget pellentesque dui. Lectus egestas purus ut cras mauris
            sed vel.
            <br />
            Justo ultricies morbi nibh eget odio vitae turpis. Aliquam vel
            tincidunt lectus lectus natoque morbi commodo fringilla. Maecenas
            malesuada feugiat imperdiet tincidunt varius. Vehicula tristique mi
            nulla nunc tortor aliquet nunc velit at. Ipsum pellentesque aliquam
            iaculis scelerisque eu convallis congue. Enim nibh id congue ipsum
            dictum parturient ut. Egestas at suspendisse volutpat accumsan
            venenatis in tempor.
            <br />A libero ut integer egestas neque et rhoncus. Est nibh viverra
            faucibus mi. Est sit ipsum vitae justo semper volutpat sit sit
            justo. Sed dolor nulla tellus consequat vivamus et tempor sagittis
            bibendum. Massa nisl vivamus urna dolor praesent commodo. Justo
            fermentum aenean hendrerit mi. Ultrices massa et auctor arcu.
            Vulputate facilisis sagittis sit integer. Commodo eros ultrices enim
            velit. At id vitae mauris pellentesque. Egestas cras sed elit eu a
            amet mauris dui. Aliquam facilisis tempor orci elementum donec
            sagittis donec pretium ultrices. Cursus ipsum sollicitudin quis non
            viverra sapien. Vulputate dictum nec lorem viverra elit dignissim
            tempus venenatis sit.
            <br />
            Hendrerit non posuere sagittis sem. Lacinia justo nibh sit iaculis
            in orci fringilla nec. Nisi porta tincidunt aliquet curabitur
            pulvinar eros metus. Suspendisse orci urna.
          </div>
        </div>
        <div className="left-[1064.25px] top-[1275px] absolute flex-col justify-start items-start gap-9 inline-flex">
          <div className="text-neutral-800 text-[42px] font-semibold font-['Poppins'] leading-[63px]">
            Similar articles
          </div>
          <div className="flex-col justify-start items-start gap-[25.50px] flex">
            <div className="h-[343.52px]  w-[295px] px-[29.29px] py-[31.82px] bg-white rounded-[22.22px] shadow flex-col justify-start items-start gap-1 flex">
              <div className="self-stretch h-[279.88px] flex-col justify-end items-start gap-[27.27px] flex">
                <div className="rounded-[7.07px] justify-end items-center inline-flex">
                  <img className="w-[274.77px] h-[194.67px]" src={img} alt="" />
                </div>
                <div className="self-stretch h-[116.74px] flex-col justify-start items-start gap-[15.66px] flex">
                  <div className="self-stretch h-[86.08px] flex-col justify-start items-start gap-[8.08px] flex">
                    <div className="self-stretch text-gray-800 text-xl font-bold font-['Poppins']">
                      Lorem ipsum dolor sit amet consectetur.
                    </div>
                    <div className="opacity-80 text-gray-800 text-xs font-normal font-['Poppins']">
                      12/12/2012
                    </div>
                  </div>
                  <div className="text-lime-800 text-sm font-bold font-['Satoshi'] leading-none">
                    Read More
                  </div>
                </div>
              </div>
            </div>
            <div className="h-[343.52px] w-[295px] px-[29.29px] py-[31.82px] bg-white rounded-[22.22px] shadow flex-col justify-start items-start gap-1 flex">
              <div className="self-stretch h-[279.88px] flex-col justify-end items-start gap-[27.27px] flex">
                <div className="rounded-[7.07px] justify-end items-center inline-flex">
                  <img className="w-[274.77px] h-[194.67px]" src={img} alt="" />
                </div>
                <div className="self-stretch h-[116.74px] flex-col justify-start items-start gap-[15.66px] flex">
                  <div className="self-stretch h-[86.08px] flex-col justify-start items-start gap-[8.08px] flex">
                    <div className="self-stretch text-gray-800 text-xl font-bold font-['Poppins']">
                      Lorem ipsum dolor sit amet consectetur.
                    </div>
                    <div className="opacity-80 text-gray-800 text-xs font-normal font-['Poppins']">
                      12/12/2012
                    </div>
                  </div>
                  <div className="text-lime-800 text-sm font-bold font-['Satoshi'] leading-none">
                    Read More
                  </div>
                </div>
              </div>
            </div>
            <div className="h-[343.52px] w-[295px] px-[29.29px] py-[31.82px] bg-white rounded-[22.22px] shadow flex-col justify-start items-start gap-1 flex">
              <div className="self-stretch h-[279.88px] flex-col justify-end items-start gap-[27.27px] flex">
                <div className="rounded-[7.07px] justify-end items-center inline-flex">
                  <img className="w-[274.77px] h-[194.67px]" src={img} alt="" />
                </div>
                <div className="self-stretch h-[116.74px] flex-col justify-start items-start gap-[15.66px] flex">
                  <div className="self-stretch h-[86.08px] flex-col justify-start items-start gap-[8.08px] flex">
                    <div className="self-stretch text-gray-800 text-xl font-bold font-['Poppins']">
                      Lorem ipsum dolor sit amet consectetur.
                    </div>
                    <div className="opacity-80 text-gray-800 text-xs font-normal font-['Poppins']">
                      12/12/2012
                    </div>
                  </div>
                  <div className="text-lime-800 text-sm font-bold font-['Satoshi'] leading-none">
                    Read More
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Emailsub />
    </>
  );
};

export default Dummyblog;
